const styles = (theme) => ({
  root: {
    position: 'relative'
  },
  hasError: {
    '@global': {
      '.form-control, .select-wrapper, button': {
        boxShadow: '0 0 0 0.2rem rgba(255, 0, 0, 0.25)'
      },
      '.form-control:focus': {
        boxShadow: '0 0 0 0.2rem rgba(255, 0, 0, 0.25)'
      },
      '.select-wrapper': {
        borderRadius: 5
      }
    }
  },
  icon: {
    position: 'absolute',
    right: -8,
    top: -10,
    backgroundColor: theme.palette.primary.contrastText
  },
  green: {
    color: 'green'
  },
  red: {
    color: 'red'
  },
  loading: {
    top: -6,
    height: 20
  }
})

export {
  styles
}
